import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';


@Injectable({
    providedIn: 'root'
})
export class FullScreenLoaderService{

    public fullScreenLoaderStatus = new BehaviorSubject(false);
    constructor(){}

    showLoader(): void{
        this.fullScreenLoaderStatus.next(true);
    }

    hideLoader(): void{
        this.fullScreenLoaderStatus.next(false);
    }

    toogleLoaderVisibility(): void{
        const currentValue = this.fullScreenLoaderStatus.getValue();
        this.fullScreenLoaderStatus.next(!currentValue);
    }
}
